export const deepObjectValue = function(obj, inputPath) {
  // console.log(obj, inputPath);
  for (var i = 0, path = inputPath.split('.'), len = path.length; i < len; i++) {
    if (obj[path[i]] || obj[path[i]] === 0) {
      obj = obj[path[i]];
    } else obj = '';
  }
  return obj;
};
